module.exports = __webpack_public_path__ + "img/car_shina2_26.7e9ff962.jpg";